import { ModuleWithProviders, NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingComponent } from './Component/Booking.Component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: BookingComponent,
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class BookingRoutingModule {
    constructor() {
        console.log('BookingRoutingModule loaded.');
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/booking/Booking.routing.ts